<template>
  <div class='map-area' :id='mapId' :type="mapType">
  </div>
</template>

<script>
import { eventBus } from '@/event-bus'
import baseMap from '@/mixin/BaseMap'
import commonUI from '@/mixin/commonUI'

export default {
  name: 'Map',
  mixins: [baseMap, commonUI],
  components: {
  },

  data: function () {
    return {}
  },

  computed: {
  },

  created () {
    // console.log('Map created...', this.mapId, this.mapType)
  },

  mounted: function () {
    eventBus.$on('sendEventMap', () => {
      this.mapStatItems = this.selectedStatItems
      this.mapStatItemYearList = this.selectedYearList

      const statItemCount = this.mapStatItems.length
      const statItemYearCount = this.mapStatItemYearList.length

      if (statItemCount > 0 && statItemYearCount > 0) {
        if (this.mapStatItemYearList.length <= this.statItemYearInfoWindowMaxCount) {
          this.showMapStatDataInfoWindow()
        } else {
          alert('지도위에 표시된 통계정보는 "해당연도" 2개 이하에서만 표시 됩니다.')
          this.showMapKoreaAreaLayer()
        }

        eventBus.$emit('sendMapLocationBoard')
      } else {
        this.resetMap()
        eventBus.$emit('closeDataBoard')
        eventBus.$emit('closeMapLocationBoard')
      }
    })
  },

  destroyed () {
    eventBus.$off('sendEventMap')
  },

  methods: {
    // 시도 통계 상세 데이터 보드
    showDetailDataBoard (areaName, areaCd) {
      eventBus.$emit('showDataBoard', areaName, areaCd)
      eventBus.$emit('showMapLocationBoard', areaName, areaCd)
    }
  }
}
</script>

<style>
.sop-infowindow-tip-container {
  height: 0px;
}
</style>
